import type { FC } from "react"

import { ConfirmationDialog } from "@/components/common/Modals"

interface QualityApprovalCancelDialogProps {
  onClose: () => void
  onConfirm: () => void
}

export const QualityApprovalCancelDialog: FC<QualityApprovalCancelDialogProps> = ({ onClose, onConfirm }) => (
  <ConfirmationDialog
    title='Cancel Out of Spec Approval'
    content='Are you sure you want to cancel this out of spec approval request?'
    closeLabel='No'
    confirmLabel='Yes, Cancel'
    testIdPrefix='quality-approval.cancel-confirmation-dialog'
    onClose={onClose}
    onConfirm={onConfirm}
  />
)
